export const stillEmployed = [
  {
    value: 'E',
    label: 'Yes',
  },{
    value: 'Rd',
    label: 'Resigned',
  },{
    value: 'T',
    label: 'Dismissed',
  },
];

export default function getStillEmployedLabelByValue(value) {
  const found = stillEmployed.find(item => item.value === value);
  return found ? found.label : 'Unknown';
}
